var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-scrollbar",
    { staticClass: "setting-scrollbar", style: { height: _vm.scrollerHeight } },
    [
      _vm.designer.selectedWidget && _vm.designer.selectedWidget.type
        ? [
            _c(
              "el-form",
              {
                staticClass: "setting-form",
                attrs: {
                  model: _vm.optionModel,
                  size: "mini",
                  "label-position": "left",
                  "label-width": "120px",
                },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "el-collapse",
                  {
                    staticClass: "setting-collapse",
                    model: {
                      value: _vm.widgetActiveCollapseNames,
                      callback: function ($$v) {
                        _vm.widgetActiveCollapseNames = $$v
                      },
                      expression: "widgetActiveCollapseNames",
                    },
                  },
                  [
                    _vm.showCollapse(_vm.commonProps)
                      ? _c(
                          "el-collapse-item",
                          {
                            attrs: {
                              name: "1",
                              title: _vm.i18nt(
                                "designer.setting.commonSetting"
                              ),
                            },
                          },
                          [
                            _vm._l(_vm.commonProps, function (A, R) {
                              return [
                                _vm.hasPropEditor(R, A)
                                  ? _c(_vm.getPropEditor(R, A), {
                                      tag: "component",
                                      attrs: {
                                        designer: _vm.designer,
                                        "selected-widget": _vm.selectedWidget,
                                        "option-model": _vm.optionModel,
                                      },
                                      on: {
                                        "update:optionModel": function (
                                          $event
                                        ) {
                                          _vm.optionModel = $event
                                        },
                                        "update:option-model": function (
                                          $event
                                        ) {
                                          _vm.optionModel = $event
                                        },
                                        clearSearch: _vm.clearSearch,
                                        optionModelChange:
                                          _vm.optionModelChange,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : !_vm.designer.selectedWidget
        ? _c("div", [
            _c("div", { staticClass: "no-widget-selected" }, [
              _c("img", {
                staticClass: "no-widget-selected-img",
                attrs: { src: require("@/assets/images/defd-da.png"), alt: "" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "no-widget-selected-text" }, [
                _vm._v("当前没有选中设置的组件"),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }